import { useEffect } from "react";
import { sessionEvents } from "../events/sessionEvents";
import { projectStore } from "./projectStore";

/**
 * Clears the selected project on auth:logout.
 *
 * PRD-003 DoD #10 mandated clearing order on logout:
 *   1. JWT (cleared by AuthContext.logout())
 *   2. /identity cache (cleared by IdentityCacheCleaner)
 *   3. selected project (cleared HERE — PRD-004)
 *   4. in-flight UI state (PRD-001 will subscribe similarly)
 *
 * Subscribers fire synchronously when sessionEvents.emit("auth:logout")
 * runs, so the order is determined by mount order in App.tsx.
 * IdentityCacheCleaner is mounted before ProjectCacheCleaner so identity
 * is cleared before project — preserving the DoD-mandated chain.
 */
export function ProjectCacheCleaner() {
    useEffect(() => {
        return sessionEvents.on("auth:logout", () => {
            projectStore.clear();
        });
    }, []);
    return null;
}
